var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-table',[_c('thead',[_c('tr',[_c('th',[_vm._v("Year")]),_c('th',{staticClass:"text-right"},[_vm._v("Type")]),_c('th')])]),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('Cell',{key:index,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }